__webpack_require__.p = "/wp-content/themes/paperpress_evolved/resources/dist/";